"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
require("./contactInfo.scss");
const common_1 = require("../../../../../utils/common");
const ContactInfo = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { contactInfo } = props;
    const address = contactInfo.address;
    const isAddressValid = !!(address && address.street_address && address.city && address.state);
    return (react_1.default.createElement(core_1.Box, { id: 'contact-info', className: 'v2-container-background' },
        react_1.default.createElement("h4", { className: 'v2-profile-block-heading' }, "Contact Information"),
        ((_a = contactInfo.phone) === null || _a === void 0 ? void 0 : _a.mobile) && react_1.default.createElement("div", { className: "info-wrapper" },
            react_1.default.createElement("span", { className: "title" }, "Main:"),
            react_1.default.createElement("a", { href: `tel: ${(_b = contactInfo.phone) === null || _b === void 0 ? void 0 : _b.mobile}`, className: "text" }, (_c = contactInfo.phone) === null || _c === void 0 ? void 0 : _c.mobile)),
        ((_d = contactInfo.phone) === null || _d === void 0 ? void 0 : _d.office) && react_1.default.createElement("div", { className: "info-wrapper" },
            react_1.default.createElement("span", { className: "title" }, "Extra:"),
            react_1.default.createElement("a", { href: `tel: ${(_e = contactInfo.phone) === null || _e === void 0 ? void 0 : _e.office}`, className: "text" }, (_f = contactInfo.phone) === null || _f === void 0 ? void 0 : _f.office)),
        ((_g = contactInfo.phone) === null || _g === void 0 ? void 0 : _g.fax) && react_1.default.createElement("div", { className: "info-wrapper" },
            react_1.default.createElement("span", { className: "title" }, "Fax:"),
            react_1.default.createElement("a", { href: `tel: ${(_h = contactInfo.phone) === null || _h === void 0 ? void 0 : _h.fax}`, className: "text" }, (_j = contactInfo.phone) === null || _j === void 0 ? void 0 : _j.fax)),
        contactInfo.email && react_1.default.createElement("div", { className: "info-wrapper" },
            react_1.default.createElement("span", { className: "title" }, "Email:"),
            react_1.default.createElement("a", { href: `mailto:${contactInfo.email}`, className: "text" }, contactInfo.email)),
        contactInfo.website && react_1.default.createElement("div", { className: "info-wrapper" },
            react_1.default.createElement("span", { className: "title" }, "Website:"),
            react_1.default.createElement("a", { onClick: () => common_1.goExternalUrl(contactInfo.website), className: "text website-text" }, contactInfo.website)),
        isAddressValid && react_1.default.createElement("div", { className: "info-wrapper" },
            react_1.default.createElement("span", { className: "title" }, "Address:"),
            react_1.default.createElement("span", { className: "text address-text" },
                address.street_address,
                ", ",
                address.city,
                ", ",
                address.state,
                " ",
                address.zip))));
};
exports.default = ContactInfo;
